<template>
  <div>
    <div class="errorRect">
      <div class="errorCenter">
        <img src="/dive/error.png">
        <div class="errorTitle">{{ title }}</div>
        <div class="errorAbout">{{ about }}</div>
        <div v-if="nativeStr" class="errorButton" :style="'color:'+GetDiveMainBack()+';border-color:'+GetDiveMainBack()">{{ nativeStr }}</div>
      </div>
    </div>
    <div v-if="backgroundColor" class="errorAllBack" :style="'background-color:'+backgroundColor" />
  </div>
</template>
<script>
import { Button } from 'vant'
import { GetDiveMainBack, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button
  },
  props: {
    // eslint-disable-next-line
    title:{
      default: '出现故障'
    },
    // eslint-disable-next-line
    about:{
      default: '别紧张,正在下潜搜寻中'
    },
    // eslint-disable-next-line
    nativeStr:{
      default: '返回'
    },
    // eslint-disable-next-line
    backgroundColor: {
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      data: {
        isNeed: false,
        url: ''
      }
    }
  },
  created() {

  },
  methods: {
    GetDiveMainBack,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle
  }
}
</script>

<style scoped>
.errorAllBack{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: -1;
}
.errorRect{
  margin-top: calc(50vh - 50vw);
}
.errorRect .errorCenter{
  text-align: center;

}
.errorRect img{
  width:30vw;

}
.errorRect .errorTitle{
  font-weight: 700;
  margin-top: 1em;
}
.errorRect .errorAbout{
  font-size: 0.8em;
  color: #999;
  margin-top: 0.5em;
  margin-bottom: 3em;
}
.errorRect .errorButton{
  width: 26vw;
  margin:0 37vw;
  border-radius: 0.4em;
  border:1px solid;
  padding: 0.25em 0;
  font-weight: 700;
}
</style>
